import React from "react";
import StatusAllPage from "../StatusAll/views/StatusAllPage";
import { StatusAllContextProvider } from "./StatusAllView";
import StatusContents from "../../constants/contentFile.json";

const StatusAllView = () => {
  return (
    <StatusAllContextProvider>
      <StatusAllPage textContents={StatusContents.status} />
    </StatusAllContextProvider>
  );
};
export default StatusAllView;
